// extracted by mini-css-extract-plugin
export default {"fab":"municipalityMapMenu_fab__uQkA9","mapSettings":"municipalityMapMenu_mapSettings__128rp","closeButton":"municipalityMapMenu_closeButton__FiDDe"};